import { defineComponent, computed, openBlock, createElementBlock, createElementVNode, createVNode, unref, toDisplayString, withModifiers, createCommentVNode, createBlock, createTextVNode } from "vue";
import { CdrRating, IconLocationPinStroke } from "@rei/cedar";
import IconThumbsUp from "../../Icons/IconThumbsUp/IconThumbsUp.mjs";
const _hoisted_1 = {
  class: "mhf-reviews"
};
const _hoisted_2 = {
  class: "mhf-reviews__container"
};
const _hoisted_3 = {
  class: "mhf-reviews__rate-section"
};
const _hoisted_4 = {
  class: "mhf-reviews__title"
};
const _hoisted_5 = {
  class: "mhf-reviews__reviewer-name mhf-reviews__reviewer-name--top"
};
const _hoisted_6 = {
  class: "mhf-reviews__publishment-datetime"
};
const _hoisted_7 = {
  class: "mhf-reviews__reviewer-received mhf-reviews__reviewer-received--top"
};
const _hoisted_8 = {
  class: "mhf-reviews__review-content"
};
const _hoisted_9 = {
  class: "mhf-reviews__details-link-container"
};
const _hoisted_10 = {
  class: "mhf-reviews__reviewer-data"
};
const _hoisted_11 = {
  class: "mhf-reviews__reviewer-name"
};
const _hoisted_12 = {
  key: 0,
  class: "mhf-reviews__reviewer-received"
};
const _hoisted_13 = {
  class: "mhf-reviews__review-data"
};
const _hoisted_14 = {
  class: "mhf-reviews__review-data-location"
};
const _hoisted_15 = {
  class: "mhf-reviews__review-useful-for"
};
const _hoisted_16 = {
  class: "mhf-reviews__useful-for-people"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductReviewsMostHelpfulFeaturedReviews",
  props: {
    usefulForLabel: {
      default: "people found this review helpful"
    },
    data: {
      default: () => ({})
    }
  },
  emits: ["metricsClick", "openMapModal"],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    const computedData = computed(() => [props.data]);
    const openMapModal = () => {
      emit("openMapModal", {
        reviews: computedData,
        photoIndex: 0,
        reviewIndex: 0
      });
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("section", _hoisted_1, [createElementVNode("div", _hoisted_2, [createElementVNode("div", _hoisted_3, [createVNode(unref(CdrRating), {
        class: "mhf-reviews__stars",
        rating: _ctx.data.rating,
        count: _ctx.data.ratingRange
      }, null, 8, ["rating", "count"])]), createElementVNode("div", _hoisted_4, toDisplayString(_ctx.data.title), 1), createElementVNode("span", _hoisted_5, toDisplayString(_ctx.data.userNickname ?? "Anonymous"), 1), createElementVNode("div", _hoisted_6, toDisplayString(_ctx.data.timeSinceSubmission), 1), createElementVNode("span", _hoisted_7, toDisplayString(_ctx.data.badges), 1), createElementVNode("div", _hoisted_8, toDisplayString(_ctx.data.reviewText), 1), createElementVNode("div", _hoisted_9, [createElementVNode("a", {
        class: "mhf-reviews__details-link",
        href: "#",
        onClick: withModifiers(openMapModal, ["stop", "prevent"])
      }, " Show Full Review ")]), createElementVNode("div", _hoisted_10, [createElementVNode("span", _hoisted_11, toDisplayString(_ctx.data.userNickname ?? "Anonymous"), 1), _ctx.data.badges ? (openBlock(), createElementBlock("span", _hoisted_12, toDisplayString(_ctx.data.badges), 1)) : createCommentVNode("", true)]), createElementVNode("div", _hoisted_13, [createElementVNode("span", _hoisted_14, [_ctx.data.userLocation ? (openBlock(), createBlock(unref(IconLocationPinStroke), {
        key: 0,
        class: "location-pin-stroke-icon"
      })) : createCommentVNode("", true), createTextVNode(" " + toDisplayString(_ctx.data.userLocation), 1)])]), createElementVNode("div", _hoisted_15, [createVNode(IconThumbsUp, {
        class: "thumbs-up-icon--green"
      }), createElementVNode("span", _hoisted_16, toDisplayString(_ctx.data.totalPositiveFeedbackCount) + " " + toDisplayString(_ctx.usefulForLabel), 1)])])]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProductReviewsMostHelpfulFeaturedReviews.mjs.map
